export const DEFAULT_TIMEZONE = 'Australia/Melbourne'

export const FLAG_SPLIT_BY_SELECTED_ITEMS = 'split-by-selected-items'
export const FLAG_REWARDS_PRICE = 'guest-app-rewards-price'
export const FLAG_MULTIPLE_MODIFIERS = 'multiple-modifiers-fe'
export const FLAG_REORDER_DRINKS_V2_BASIC = 'reorder-drinks-v2-basic'
export const FLAG_ONE_CLICK_PAYMENTS = 'one-click-payments'
export const FLAG_REWARDS_BALANCE = 'guest-app-rewards-balance'
export const FLAG_MODIFYING_UPSELLS = 'modifying-upsells'
export const FLAG_STACK_POINTS_ON_DISCOUNTS = 'stack-points-on-discounts'
export const FLAG_ALLOW_POSITIONING_INFO_BLOCKS =
  'allow-positioning-info-blocks'
export const FLAG_NEW_REDEEM_POINTS_VALUE = 'loy-redemption-panel-points'
export const FLAG_POINTS_TO_USE_POLLING = 'loy-points-to-use-polling'
export const FLAG_LOGIN_AS_ANON_GUEST = 'login-as-anon-guest'
export const FLAG_POST_SALES_TAX_TIP = 'post-sales-tax-tip'
export const FLAG_REWARD_GUEST_VOUCHERS = 'reward-guest-vouchers'
export const FLAG_REWARD_GUEST_VOUCHER_BARCODES =
  'reward-guest-voucher-barcodes'
export const FLAG_REWARD_ENABLE_AURA_OAUTH = 'serve-frontend.enable-aura-oauth'
export const FLAG_ENABLE_FALLBACK_IMAGE = 'serve-frontend.enable-fallback-image'
export const FLAG_VALIDATE_UPSELLS_MODAL_IN_CART =
  'serve-frontend.validate-upsells-modal-in-cart'
export const FLAG_DISABLE_PAYMENT_PAGE_ORDER_TOTAL_CHANGES =
  'serve-frontend.disable-payment-page-order-total-changes'
export const FLAG_CLOUDFLARE_TURNSTILE = 'serve.enable-cloudflare-turnstile'
export const FLAG_DISABLE_REORDER_DRINKS =
  'serve-frontend.disable-reorder-drinks-on-venue-landing-page'

export const FLAG_TABLE_RULE_IN_CART = 'manage-api.crew.table-rule-in-cart'
export const FLAG_START_WITH_DRINKS = 'serve-frontend.start-with-drinks'
export const FLAG_CREW_REVIEWS = 'crew.reviews'
export const FLAG_HIDE_DISPLAY_PRICE_WITH_ZERO_VALUE =
  'serve-frontend.hide-display-price-with-zero-value'
